export enum OnSiteLocationKeys {
  Id = 'id',
  Name = 'name',
  ShopId = 'shop_id',
  Handle = 'handle',
  Enabled = 'enabled',
}
